function EventModal({ event, onClose }) {
  if (!event) return null;

  const tz = 'America/Chicago';

  function formatDateTime(date, allDay) {
    if (allDay) {
      return date.toLocaleDateString('en-US', {
        timeZone: tz,
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    }
    return date.toLocaleString('en-US', {
      timeZone: tz,
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    });
  }

  function formatEndTime(event) {
    if (event.allDay) {
      const endDisplay = new Date(event.end);
      endDisplay.setDate(endDisplay.getDate() - 1);
      const startStr = event.start.toLocaleDateString('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
      const endStr = endDisplay.toLocaleDateString('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' });
      if (endStr === startStr) return null;
      return endDisplay.toLocaleDateString('en-US', {
        timeZone: tz,
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
    }
    const startDay = event.start.toLocaleDateString('en-US', { timeZone: tz });
    const endDay = event.end.toLocaleDateString('en-US', { timeZone: tz });
    if (endDay === startDay) {
      return event.end.toLocaleTimeString('en-US', {
        timeZone: tz,
        hour: 'numeric',
        minute: '2-digit',
      });
    }
    return formatDateTime(event.end, false);
  }

  const endStr = formatEndTime(event);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{event.summary}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="modal-row">
            <span className="modal-label">When</span>
            <span className="modal-value">
              {formatDateTime(event.start, event.allDay)}
              {endStr && <> &mdash; {endStr}</>}
            </span>
          </div>
          {event.location && (
            <div className="modal-row">
              <span className="modal-label">Where</span>
              <span className="modal-value">{event.location}</span>
            </div>
          )}
          {event.description && (
            <div className="modal-row">
              <span className="modal-label">Details</span>
              <span className="modal-value modal-description">{event.description}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EventModal;
